import OpinonsWrap from "@home/pages/studio/opinions/OpinonsWrap";
import OpinionsFilter from "@home/pages/studio/opinions/OpinionsFilter";
import GameStore from "@home/pages/studio/opinions/GameStore";
import CommunityPerformance from "@home/pages/studio/opinions/CommunityPerformance";
import StudioTrendingVideo from "@home/pages/studio/opinions/StudioTrendingVideo";
import GoogleTrends from "@home/pages/studio/opinions/GoogleTrends";
import PR from "@home/pages/studio/opinions/PR";
import LanguageChannel from "@home/pages/studio/opinions/LanguageChannel";
import OpinionsReportFilterLeft from "@home/pages/studio/opinions/components/OpinionsReportFilterLeft";
import GPTReport from "@home/pages/studio/opinions/components/GPTReport";
import CommonTitle from "@home/pages/studio/components/CommonTitle";
import CommonLayout from "@home/pages/studio/components/CommonLayout";
import ScrollTabs from "@home/pages/studio/components/ScrollTabs";
import OpinionsVideo from "@home/pages/studio/opinions/components/OpinionsVideo";
import OpinionsVideoInFluencers from "@home/pages/studio/opinions/components/OpinionsVideoInFluencers";
import OpinionsTrendVideo from "@home/pages/studio/opinions/components/OpinionsTrendVideo";
import OpinionsPosts from "@home/pages/studio/opinions/components/OpinionsPosts";
import OpinionsTrendPosts from "@home/pages/studio/opinions/components/OpinionsTrendPosts";
import OpinionsAccountsFollowers from "@home/pages/studio/opinions/components/OpinionsAccountsFollowers";
import OpinionsAccountsOverview from "@home/pages/studio/opinions/components/OpinionsAccountsOverview";
import OpinonsChannelLanguge from "@home/pages/studio/opinions/components/OpinionsChannelLanguge";
import KPIs from "@home/pages/studio/opinions/KPIs";
import GPTWrap from "@home/pages/studio/opinions/components/GPTWrap";
import EditGpt from "@home/pages/studio/opinions/components/EditGpt";
import OpinionsGameStore from "@home/pages/studio/opinions/OpinionsGameStore";
import OpinionsCommonData from "@home/pages/studio/opinions/components/OpinionsCommonData";
import EditHighlights from "@home/pages/studio/opinions/components/HighlightsReport/EditHighlights";
import HighlightsWrap from "@home/pages/studio/opinions/components/HighlightsReport/HighlightsWrap";
import HighlightsReport from "@home/pages/studio/opinions/components/HighlightsReport";
import SentimentTopicsDeepDive from "@home/pages/studio/opinions/SentimentTopicsDeepDive";
import AppendixWrap from "@home/pages/studio/opinions/components/Appendix/AppendixWrap";
import EditAppendix from "@home/pages/studio/opinions/components/Appendix/EditAppendix";
import AppendixReport from "@home/pages/studio/opinions/components/Appendix";
import OpinionsStreaming from "@home/pages/studio/opinions/components/OpinionsStreaming";
import OpinionsStreamingChannleShare from "@home/pages/studio/opinions/components/OpinionsStreaming/OpinionsStreamingChannleShare";
import OpinionsFooter from "@home/pages/studio/opinions/components/OpinionsFooter";
import OpinionsScrollTabs from "@home/pages/studio/opinions/components/OpinionsScrollTabs";
import OfficialAccounts from "@home/pages/studio/opinions/OfficialAccounts";
import Influencers from "@home/pages/studio/opinions/Influencers";
import GameStoreV2 from "@home/pages/studio/opinions/GameStore/GameStoreV2";
import OpinionsTopicKeyword from "@home/pages/studio/opinions/components/OpinionsTopicKeyword";
import OpinionsGameStoreMobile from "@home/pages/studio/opinions/OpinionsGameStoreMobile";
import AdCreativesWrapper from "@home/pages/studio/components/AdCreativesWrapper";
import TrendingPostsVdieoWrapper from "@home/pages/studio/components/TrendingPostsVdieoWrapper";
import ZoneTrendingPublicationsAdapter from "@home/pages/studio/components/ZoneTrendingPublicationsAdapter";
import InfluencerWrapper from "@home/pages/studio/components/InfluencerWrapper";
import CreativeTrendsWrapper from "@home/pages/studio/components/CreativeTrendsWrapper";
import ZoneTopCreatives from "@opm/pages/ZoneTopCreatives";
import CompetitorAdComparison from "@opm/pages/CompetitorAdComparison";
import CreativeTrends from "@opm/pages/CreativeTrends";
import InfluencerBrandOverview from "@op/pages/Influencer/BrandOverview";
import InfluencerBrandCreatorList from "@op/pages/Influencer/BrandCreatorList";

export default {
  OpinonsWrap,
  OpinionsFilter,
  GameStore,
  CommunityPerformance,
  StudioTrendingVideo,
  GoogleTrends,
  PR,
  LanguageChannel,
  OpinionsReportFilterLeft,
  GPTReport,
  CommonTitle,
  CommonLayout,
  ScrollTabs,
  OpinionsVideo,
  OpinionsVideoInFluencers,
  OpinionsTrendVideo,
  OpinionsPosts,
  OpinionsTrendPosts,
  OpinionsAccountsFollowers,
  OpinionsAccountsOverview,
  OpinonsChannelLanguge,
  KPIs,
  GPTWrap,
  EditGpt,
  OpinionsGameStore,
  OpinionsCommonData,
  HighlightsWrap,
  HighlightsReport,
  EditHighlights,
  SentimentTopicsDeepDive,
  AppendixWrap,
  AppendixReport,
  EditAppendix,
  OpinionsStreaming,
  OpinionsStreamingChannleShare,
  OpinionsFooter,
  OpinionsScrollTabs,
  OfficialAccounts,
  Influencers,
  GameStoreV2,
  OpinionsTopicKeyword,
  OpinionsGameStoreMobile,
  AdCreativesWrapper,
  TrendingPostsVdieoWrapper,
  ZoneTrendingPublicationsAdapter,
  InfluencerWrapper,
  CreativeTrendsWrapper,
  ZoneTopCreatives,
  CompetitorAdComparison,
  CreativeTrends,
  InfluencerBrandOverview,
  InfluencerBrandCreatorList,
};
